"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveMenu = void 0;
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const React = tslib_1.__importStar(require("react"));
const react_collapse_1 = require("react-collapse");
const react_dom_1 = tslib_1.__importDefault(require("react-dom"));
const EventStack_1 = tslib_1.__importDefault(require("../EventStack"));
const Icon_1 = tslib_1.__importDefault(require("../Icon"));
const MediaManagerImage_1 = tslib_1.__importDefault(require("../MediaManagerImage"));
const styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
const utilities_1 = require("../Themes/utilities");
const siteUrl_1 = tslib_1.__importDefault(require("./siteUrl"));
const linkClass = 'responsive-menu-link';
const WIDTH_RESPONSIVE_MENU = 290;
const WrapperRow = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
`;
const WrapperSection = styled_components_1.default.div `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
`;
const Overlay = styled_components_1.default.div `
  position: fixed;
  z-index: 121;
  overflow-y: auto;

  -webkit-overflow-scrolling: touch;
  flex-wrap: wrap;
  display: flex;
  top: 0;
  transition: all 0.35s;
  ${({ position, visible }) => {
    if (position === 'left') {
        return styled_components_1.css `
        left: ${visible ? '0%' : '-100%'};
      `;
    }
    else {
        return styled_components_1.css `
        right: ${visible ? '0%' : '-100%'};
      `;
    }
}}
  width: 85%;
  height: 100%;
  background: ${({ theme }) => theme.responsiveMenu.backgroundColor};
  ${utilities_1.mb('xs')} {
    ${({ visible }) => visible &&
    styled_components_1.css `
        width: ${polished_1.rem(WIDTH_RESPONSIVE_MENU)};
      `}
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;
const CloseButtonContainer = styled_components_1.default.div `
  height: 50px;
  width: 85%;
`;
const CloseButtonFixed = styled_components_1.default.div `
  padding: ${polished_1.rem(10)} ${polished_1.rem(13)};
  position: fixed;
  width: 85%;
  ${utilities_1.mb('xs')} {
    width: ${polished_1.rem(WIDTH_RESPONSIVE_MENU)};
  }
  background: ${({ theme }) => theme.responsiveMenu.backgroundColor};
`;
const CloseButton = styled_components_1.default.div `
  width: ${polished_1.rem(50)};
  ${({ position }) => {
    if (position === 'right') {
        return styled_components_1.css `
        margin-left: auto;
        width: ${polished_1.rem(26)};
        display: block;
      `;
    }
    else {
        return styled_components_1.css ``;
    }
}}
`;
const CloseIcon = styled_components_1.default(Icon_1.default) `
  cursor: pointer;
`;
const SIcon = styled_components_1.default(CloseIcon) `
  margin-right: 10px;
`;
const ContentWrapper = styled_components_1.default.div `
  width: 100%;
  .ReactCollapse--collapse {
    transition: height 250ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  .${linkClass} {
    width: 100%;
    padding: 0;
    border: none;
    font: inherit;
    background: none;
    cursor: pointer;
    display: flex;
    padding: ${polished_1.rem(10)};
    padding-left: ${polished_1.rem(13)};
    font-size: ${polished_1.rem(12)};
    color: ${({ theme }) => theme.responsiveMenu.linkColor};
    font-weight: normal;
    text-decoration: none;
    outline: none;
    align-items: center;
  }

  /* level 1 */
  & > ul {
    margin-top: 0;
    margin: 0;
    & > li {
      & > .${linkClass} {
        height: ${polished_1.rem(40)};
        display: flex;
        align-items: center;
        font-size: ${polished_1.rem(14)};
        font-weight: bold;
        text-transform: uppercase;
      }
      & > div > .${linkClass} {
        height: ${polished_1.rem(40)};
        display: flex;
        align-items: center;
        font-size: ${polished_1.rem(14)};
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }

  /* level 2 */
  & > ul > li > div > div > ul {
    background: ${({ theme }) => utilities_1.emphasizeColor(0.02, `${theme.responsiveMenu.backgroundColor}`)};
    & > li > div > div > ul {
      margin: 0;
      background: ${({ theme }) => utilities_1.emphasizeColor(0.06, `${theme.responsiveMenu.backgroundColor}`)};
    }
    & > li > .${linkClass} {
      font-size: ${polished_1.rem(13)};
      font-weight: bold;
      color: ${({ theme }) => theme.responsiveMenu.linkColorHighlighted};
    }
    & > li > div > .${linkClass} {
      font-size: ${polished_1.rem(13)};
      font-weight: bold;
      color: ${({ theme }) => theme.responsiveMenu.linkColorHighlighted};
    }
  }
`;
const ListWrapper = styled_components_1.default.ul `
  display: block;
  padding: 0;
  margin: 0;
  & > {
    :focus,
    :hover {
      background: ${({ theme }) => utilities_1.emphasizeColor(0.09, `${theme.responsiveMenu.backgroundColor}`)};
    }
  }
`;
const List = styled_components_1.default.li `
  list-style-type: none;
  font-weight: bold;
  font-size: ${polished_1.rem(14)};
`;
const SidebarBackdrop = styled_components_1.default('div') `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 120;
  transition: all 0.35s;
  background-color: ${({ theme }) => theme.responsiveMenu.backdropColor};
  ${({ isOpen }) => {
    if (isOpen) {
        return styled_components_1.css `
        opacity: 1;
      `;
    }
    else {
        return styled_components_1.css `
        pointer-events: none;
        opacity: 0;
      `;
    }
}}
`;
const StyledMediaManagerImage = styled_components_1.default(MediaManagerImage_1.default) `
  width: 24px;
  flex-shrink: 0;
  margin-right: 13px;
`;
const bodyOverflowHiddenClass = 'responsive-menu-opened';
const defaultProps = {
    depthLevel: 3,
    position: 'right',
};
let element = null;
let menuRoot;
if (typeof document !== 'undefined') {
    element = document.createElement('div');
    element.setAttribute('id', 'menu-root');
    menuRoot = document.body.appendChild(element);
}
const GlobalStyle = styled_components_1.createGlobalStyle `
  body.${bodyOverflowHiddenClass} {
    overflow: hidden;
  }
`;
class ResponsiveMenu extends React.PureComponent {
    constructor(props) {
        super(props);
        this.init = () => {
            document.body.classList.add(bodyOverflowHiddenClass);
            if (typeof document !== 'undefined') {
                EventStack_1.default.add(document.body, 'keydown', this.handleKeyDown);
            }
        };
        this.destroy = () => {
            document.body.classList.remove(bodyOverflowHiddenClass);
            if (typeof document !== 'undefined') {
                EventStack_1.default.remove(document.body, 'keydown', this.handleKeyDown);
            }
        };
        this.handleKeyDown = (e) => {
            const { onClose } = this.props;
            if (e.key === 'Escape') {
                onClose();
            }
        };
        this.handeleCollapse = (id) => {
            if (this.state.openedSubmenuIdx.includes(id)) {
                var newOpenedSubmenuIdx = [...this.state.openedSubmenuIdx];
                var index = newOpenedSubmenuIdx.indexOf(id);
                if (index !== -1) {
                    newOpenedSubmenuIdx.splice(index, 1);
                    this.setState({ openedSubmenuIdx: newOpenedSubmenuIdx });
                }
            }
            else {
                this.setState({
                    openedSubmenuIdx: [...this.state.openedSubmenuIdx, id],
                });
            }
        };
        this.itemRenderer = (section, level, color) => {
            const { depthLevel, renderLink, onClickLink, onClose } = this.props;
            const linkChildren = (React.createElement(React.Fragment, null,
                section.icon && (React.createElement(StyledMediaManagerImage, { picture: section.icon, naturalHeight: 24, naturalWidth: 24 })),
                React.createElement(WrapperSection, null, section.name)));
            const linkChildrenWoIcon = React.createElement(WrapperSection, null, section.name);
            return (React.createElement(List, { key: String(section._id) },
                !section.sections ||
                    section.sections.length === 0 ||
                    level === depthLevel ? (renderLink ? (renderLink({
                    section,
                    linkProps: {
                        className: linkClass,
                        onClick: onClose,
                        children: linkChildren,
                    },
                    level,
                })) : onClickLink ? (React.createElement("button", { className: linkClass, onClick: () => onClickLink(section) }, linkChildren)) : (React.createElement("span", { className: linkClass }, linkChildren))) : (React.createElement(WrapperRow, { onClick: () => {
                        this.handeleCollapse(section._id);
                    } },
                    React.createElement("button", { className: linkClass }, linkChildren),
                    this.state.openedSubmenuIdx.includes(section._id) ? (React.createElement(SIcon, { name: "arrow-down", color: color })) : (React.createElement(SIcon, { name: "arrow-right", color: color })))),
                section.sections &&
                    section.sections.length > 0 &&
                    level < depthLevel && (React.createElement(react_collapse_1.UnmountClosed, { isOpened: this.state.openedSubmenuIdx.includes(section._id) },
                    React.createElement(ListWrapper, null,
                        renderLink
                            ? renderLink({
                                section,
                                linkProps: {
                                    className: linkClass,
                                    onClick: onClose,
                                    children: linkChildrenWoIcon,
                                },
                                level,
                            })
                            : onClickLink && (React.createElement("button", { className: linkClass, onClick: () => onClickLink(section) }, linkChildren)),
                        section.sections.map(item => this.itemRenderer(item, level + 1, color)))))));
        };
        this.state = {
            active: false,
            openedSubmenuIdx: [],
        };
    }
    componentDidMount() {
        this.setState({ active: true });
        if (this.props.visible === true) {
            this.init();
        }
    }
    componentDidUpdate(prevProps) {
        const { visible } = this.props;
        if (typeof document !== 'undefined') {
            if (visible === true && prevProps.visible === false) {
                this.init();
            }
            if (visible === false && prevProps.visible === true) {
                this.destroy();
            }
        }
    }
    componentWillUnmount() {
        this.destroy();
    }
    render() {
        const { visible, onClose, sections, siteUrl, theme, position } = this.props;
        const { active } = this.state;
        if (!active) {
            // portals are not supported serverside
            // whole point of "active" is, that when this component gets
            // server-rendered, it throws a nasty error about invalid
            // target element for rendering
            // it's hacky, but it works
            return null;
        }
        return react_dom_1.default.createPortal(React.createElement(React.Fragment, null,
            React.createElement(SidebarBackdrop, { isOpen: visible, onClick: onClose }),
            React.createElement(Overlay, { visible: visible, position: position },
                React.createElement(ContentWrapper, null,
                    React.createElement(CloseButtonContainer, null,
                        React.createElement(CloseButtonFixed, null,
                            React.createElement(CloseButton, { onClick: onClose, position: position },
                                React.createElement(CloseIcon, { size: 26, name: "close", color: theme.responsiveMenu.closeButtonColor || '#fff' })))),
                    React.createElement(ListWrapper, null, sections.map(item => this.itemRenderer(item, 1, theme.responsiveMenu.linkColor)))),
                siteUrl && React.createElement(siteUrl_1.default, { siteUrl: siteUrl })),
            React.createElement(GlobalStyle, null)), menuRoot);
    }
}
exports.ResponsiveMenu = ResponsiveMenu;
ResponsiveMenu.defaultProps = defaultProps;
exports.default = styled_components_1.withTheme(ResponsiveMenu);
